import { Badge } from '@mantine/core'
import React from 'react'

export default function FormStatusChip({filled}) {
    if(filled)return ( <Badge variant='filled'  color='green'>Rempli </Badge> )
    return <Badge variant="filled" color='orange'>Non Rempli</Badge>
}
